import axios from 'axios'

export const api = axios.create({
  // baseURL: 'https://cabelegria.ideiasadman.com.br/api/',
  baseURL: 'https://www.cabelegria.org/api/',
})
